module.exports = __webpack_public_path__ + "img/lvboqi.prt.22e9460e.jpg";